export default {
  NOT_SET: 'not-set',
  FREE_TRIAL: 'free-trial',
  DIFM_BANNER: 'difm-banner-gold',
  DIFM_BADGE: 'difm-badge-gold',
};
